/**
 * Product media videos: autoplay + loop + sound (jahan browser allow kare).
 *
 * Browsers bina user interaction ke sound wali autoplay block karte hain, isliye:
 *  - user ne page par kuch tap/click/key kiya ho (swipe ka touchend bhi gina jaata hai) -> video unmuted play hota hai
 *  - nahi kiya ho -> pehle muted autoplay, aur pehli interaction par turant unmute
 *  - video sirf tab chalta hai jab slider me dikh raha ho, slide badalte hi pause
 *
 * Sirf <video data-autoplay-sound> par kaam karta hai (snippets/video.liquid lagata hai).
 */
(() => {
  if (window.__videoSoundInit) return;
  window.__videoSoundInit = true;

  const SELECTOR = 'video[data-autoplay-sound]';
  let activated = !!(navigator.userActivation && navigator.userActivation.hasBeenActive);

  /** @param {HTMLVideoElement} video */
  function start(video) {
    video.loop = true;
    video.setAttribute('playsinline', '');
    video.muted = !activated;

    const playing = video.play();
    if (playing && playing.catch) {
      // Sound ke saath play block hua -> muted fallback
      playing.catch(() => {
        video.muted = true;
        video.play().catch(() => {});
      });
    }
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        const video = /** @type {HTMLVideoElement} */ (target);
        video.dataset.inView = isIntersecting ? '1' : '';
        if (isIntersecting) start(video);
        else video.pause();
      });
    },
    { threshold: 0.6 }
  );

  /** @param {HTMLVideoElement} video */
  function observe(video) {
    if (video.dataset.soundBound) return;
    video.dataset.soundBound = '1';
    video.loop = true;
    io.observe(video);
  }

  document.querySelectorAll(SELECTOR).forEach((v) => observe(/** @type {HTMLVideoElement} */ (v)));

  // Slider / section re-render ke baad aane wale videos
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        const el = /** @type {Element} */ (node);
        if (el.matches(SELECTOR)) observe(/** @type {HTMLVideoElement} */ (el));
        el.querySelectorAll?.(SELECTOR).forEach((v) => observe(/** @type {HTMLVideoElement} */ (v)));
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Pehli user interaction: dikh rahe muted videos ko unmute karo
  const EVENTS = ['pointerdown', 'pointerup', 'touchend', 'mousedown', 'click', 'keydown'];
  function onFirstInteraction() {
    activated = true;
    EVENTS.forEach((t) => window.removeEventListener(t, onFirstInteraction, true));

    document.querySelectorAll(SELECTOR).forEach((v) => {
      const video = /** @type {HTMLVideoElement} */ (v);
      if (video.dataset.inView === '1' && !video.paused && video.muted) video.muted = false;
    });
  }

  if (!activated) {
    EVENTS.forEach((t) => window.addEventListener(t, onFirstInteraction, true));
  }
})();